"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminAddManualCommitmentResponseToJSON = exports.AdminAddManualCommitmentResponseFromJSONTyped = exports.AdminAddManualCommitmentResponseFromJSON = void 0;
var runtime_1 = require("../runtime");
function AdminAddManualCommitmentResponseFromJSON(json) {
    return AdminAddManualCommitmentResponseFromJSONTyped(json, false);
}
exports.AdminAddManualCommitmentResponseFromJSON = AdminAddManualCommitmentResponseFromJSON;
function AdminAddManualCommitmentResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'success': !(0, runtime_1.exists)(json, 'success') ? undefined : json['success'],
        'userId': !(0, runtime_1.exists)(json, 'userId') ? undefined : json['userId'],
        'userEmail': !(0, runtime_1.exists)(json, 'userEmail') ? undefined : json['userEmail'],
        'commitmentAmountUsd': !(0, runtime_1.exists)(json, 'commitmentAmountUsd') ? undefined : json['commitmentAmountUsd'],
        'totalUserCommitmentUsd': !(0, runtime_1.exists)(json, 'totalUserCommitmentUsd') ? undefined : json['totalUserCommitmentUsd'],
        'message': !(0, runtime_1.exists)(json, 'message') ? undefined : json['message'],
    };
}
exports.AdminAddManualCommitmentResponseFromJSONTyped = AdminAddManualCommitmentResponseFromJSONTyped;
function AdminAddManualCommitmentResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'success': value.success,
        'userId': value.userId,
        'userEmail': value.userEmail,
        'commitmentAmountUsd': value.commitmentAmountUsd,
        'totalUserCommitmentUsd': value.totalUserCommitmentUsd,
        'message': value.message,
    };
}
exports.AdminAddManualCommitmentResponseToJSON = AdminAddManualCommitmentResponseToJSON;
